import { api_DELETE, api_GET, api_POST, api_PUT } from './_api';

const manejoResiduo_api = {
    GetListManejoResiduo: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`ManejoResiduo/GetListManejoResiduo`, obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    PostManejoResiduo: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`ManejoResiduo/InsertManejoResiduo`, obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    PutManejoResiduo: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`ManejoResiduo/UpdateManejoResiduo`, obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    DeleteManejoResiduo: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_DELETE(`ManejoResiduo/DeleteManejoResiduo/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
}

export default manejoResiduo_api;